import Input from "../../../components/Input/Input";
import { getNestedValue, setNestedValue } from "../../../utils/object";

export function PartialFormUniview({ configuration, setConfiguration, setEditablePort, ...props }) {
   function onChange(field, value) {
      const currentValue = getNestedValue(configuration, field);
      if (currentValue === value) return;
      setConfiguration(setNestedValue({ ...configuration }, field, value));
   }

   return (
      <div className="w-full grid grid-cols-2 gap-2.5">
         <Input
            name="confidence"
            id="confidence"
            type="number"
            labelText="Confidence (%)"
            tooltipVisible={true}
            tooltipText="(0 = ignorar)"
            value={configuration?.confidence}
            onChange={({ target }) => onChange('confidence', target.value)}
            disabled={props.type === "consulta"}
            required={true}
         />
         <Input
            name="eventTimeout"
            id="eventTimeout"
            type="number"
            labelText="Timeout de Evento"
            tooltipVisible={true}
            tooltipText="Eventos registrados após esse tempo em segundos, serão ignorados. (0 = ignorar verificação)"
            value={configuration?.eventTimeout}
            onChange={({ target }) => onChange('eventTimeout', target.value)}
            disabled={props.type === "consulta"}
            required={true}
         />
      </div>
   );
}